import { useEffect, useState, useSyncExternalStore } from "react";
import {
  listQueue,
  subscribeQueue,
  type QueuedOrder,
} from "@/lib/offline/queue";

function subscribe(callback: () => void) {
  return subscribeQueue(callback);
}

let version = 0;
const bumpVersion = () => {
  version += 1;
};
subscribeQueue(bumpVersion);

function getSnapshot() {
  return version;
}

export function useOfflineQueue() {
  useSyncExternalStore(subscribe, getSnapshot);
  const [orders, setOrders] = useState<QueuedOrder[]>([]);

  useEffect(() => {
    let cancelled = false;
    listQueue().then((items) => {
      if (!cancelled) setOrders(items);
    });

    return () => {
      cancelled = true;
    };
  }, [version]);

  const pendingCount = orders.filter(
    (o) => o.status === "pending" || o.status === "failed",
  ).length;
  const failedCount = orders.filter((o) => o.status === "failed").length;

  return { orders, pendingCount, failedCount };
}
